// TODO(stripe-reimpl): legacy Stripe billing, disabled while we're betaAccess-only. Rebuild on the new billing system.

export const BILLING_DISABLED_MESSAGE =
  "Billing isn't available during the beta. Please contact support if you need help.";

/** Stand-in for a billing action whose Stripe backend has been removed. */
export const notifyBillingDisabled = (feature) => {
  console.warn(`[stripe-reimpl] ${feature} called while billing is disabled`);
  window.alert(BILLING_DISABLED_MESSAGE);
};
